export default __webpack_public_path__ + "static/media/Ape.8c59ce66.mp4";